<template>
  <div id="Register" class="view">
    <p>Dette er den eneste gangen du kan endre navn og bilde. Pass på at det er riktig</p>
    <form class="fields" v-on:submit.prevent="submit">
      <Avatar v-model="avatar" @error="(err) => this.error = err" />
      <input type="text" style="text-transform: capitalize;"
        max-length="30" autocomplete="fullname" name="fullname" v-model="fullname"
        placeholder="Fultnavn" />
      <transition name="fade">
        <p v-if="error" class="is_error">{{error}}</p>
      </transition>
      <button class="btn submit" @click="submit" :disabled="isDisabled">Fullfør</button>
    </form>
    <Loader :visible="loading" />
  </div>
</template>

<script>
/* Helpers */
import { db } from '@/fire'
/* Components */
import Avatar from '@/components/Avatar.vue'
import Loader from '@/components/Loader.vue'

export default {
  name: 'Register',
  data () {
    return {
      fullname: '',
      avatar: '',
      thumbnail: '',
      error: '',
      loading: false,
    }
  },
  components: {
    Avatar,
    Loader,
  },
  computed: {
    authUser () {
      return this.$store.state.user.authUser
    },
    isDisabled () {
      return this.avatar.length < 6 || !this.isFullname(this.fullname)
    },
  },
  methods: {
    onError (error) {
      this.error = error.message
      this.loading = false
    },
    submit () {
      if (this.loading) return
      this.error = ''
      if (!this.isDisabled && this.authUser.uid) {
        this.loading = true

        db.collection('users').doc(this.authUser.uid).set({
          fullname: this.fullname.replace(/\b\w/g, l => l.toUpperCase()),
        }, { merge: true }).catch((error) => {
          this.loading = false
          console.warn(error)
          this.error = error.message
        })
      } else {
        this.error = 'Fyll ut både først- og sistenavn'
      }
    },
    isFullname (value) {
      if (value.length < 4) return false
      const reg = /^(([a-zåøæàáâäãåąčćęèéêëėįìíîïłńòóôöõùúûüųūÿýżźñçčšž-]){2,}((\ ([a-zåøæàáâäãåąčćęèéêëėįìíîïłńòóôöõùúûüųūÿýżźñçčšž-]){2,})+))$/i
      return !!reg.test(value)
    },
  },
}
</script>

<style lang="scss">
#Register {
  background: var(--offwhite);


}
</style>
